// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__136Jc","largestCol":"styles_largestCol__30J3k","smallestCol":"styles_smallestCol__3RIK1"};